<svg class="svg-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M889 303v556H141V303h748m20-80H121c-33.1 0-60 26.9-60 60v596c0 33.1 26.9 60 60 60h788c33.1 0 60-26.9 60-60V283c0-33.1-26.9-60-60-60z"
        stroke="black" stroke-width="30" fill="none" />
    <path
        d="M943 175v48H80v-48h863m20-80H60c-33.1 0-60 26.9-60 60v88c0 33.1 26.9 60 60 60h903c33.1 0 60-26.9 60-60v-88c0-33.1-26.9-60-60-60zM617 445v24H406v-24h211m20-80H386c-33.1 0-60 26.9-60 60v64c0 33.1 26.9 60 60 60h251c33.1 0 60-26.9 60-60v-64c0-33.1-26.9-60-60-60z"
        stroke="black" stroke-width="30" fill="none" />
</svg>